import spartaEventsUtility from "utilities/global/sparta-events-utility/2.4.2/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.3.0/js/sparta-global-functions-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import _ from "utilities/vendor/lodash/4.18.1/js/lodash.custom.min";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.2.1/js/sparta-transport-utility";
import Handlebars from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import currentWidgetDetails from "utilities/platform/widget-details";


const CURRENT_TIME = Date.now();
const PERSIST_KEY = 'spartaTestExperiences';
const QS_PREFIX_KEY = 'experience';
const QS_DEBUG_KEY = 'experience-debug';
const QS_DEBUG_RESET_KEY = 'reset';
const EXPERIENCE_SCOPES = ['global', 'site', 'page'];
const SPARTA_EVENT_NAME = 'sparta-experiences-ready';
const DEFAULT_TESTS = {
  global: {},
  site: {},
  page: {},
};
const MANIFEST_TIMEOUT = 500;






function getTestsFromManifest() {
  return new Promise((resolve) => {
    if (spaParams.experiencesPath) {
      spartaTransportUtility.subscribe({
        url: spaParams.experiencesPath,
        success: resolve,
        error: () => {
          resolve(DEFAULT_TESTS);
        },
        timeout: MANIFEST_TIMEOUT,
      });
    } else {
      resolve(DEFAULT_TESTS);
    }
  });
}







function forAllTests(tests, callback) {
  _.forEach(tests, (testsInScope, scope) => {
    _.forEach(testsInScope, (test, testName) => {
      callback({
        testsInScope,
        scope,
        test,
        testName,
      });
    });
  });
}






function isTestInTimeRange(test) {
  return (
    CURRENT_TIME >= new Date(test.runDates.start).getTime()
    && CURRENT_TIME <= new Date(test.runDates.end).getTime()
  );
}






function filterTests(allTests) {
  const filteredTests = _.cloneDeep(allTests);

  forAllTests(filteredTests, ({
    testsInScope,
    scope,
    test,
    testName,
  }) => {
    const scopedTests = testsInScope;

    if (
      !isTestInTimeRange(test)
      || (scope === 'site' && test.name !== spaParams.siteName)
      || (scope === 'page' && !window.location.pathname.includes(test.path))
    ) {
      delete scopedTests[testName];
    }

    return scopedTests;
  });

  if (spartaGlobalFunctions.getUrlParam(QS_DEBUG_KEY)) {
    console.warn('Applicable experiences: ', filteredTests);
  }

  return filteredTests;
}






function weightedRand(spec) {
  const table = [];
  let j;

  _.forEach(spec, (value, key) => {
    for (j = 0; j < value * 100; j += 1) {
      table.push(key);
    }
  });

  return table[Math.floor(Math.random() * table.length)];
}






function getRandomWeightedExperience(experiences) {
  return weightedRand(_.reduce(experiences, (total, experience) => {
    const newTotal = total;

    newTotal[experience.name] = experience.weight;

    return newTotal;
  }, {}));
}






function persistTests(tests) {
  if (spartaGlobalFunctions.getUrlParam(QS_DEBUG_KEY)) {
    console.warn('All chosen experiences: ', tests);
  }

  spartaStoreUtility.persist(PERSIST_KEY, tests);
}





function getPersistedTests() {
  if (spartaGlobalFunctions.getUrlParam(QS_DEBUG_KEY) === QS_DEBUG_RESET_KEY) {
    spartaStoreUtility.removePersisted(PERSIST_KEY);
  }

  return spartaStoreUtility.getPersisted(PERSIST_KEY) || DEFAULT_TESTS;
}






function chooseExperiencesForTests(allTests) {
  const persistedTests = getPersistedTests();

  forAllTests(allTests, ({
    scope,
    test,
    testName,
  }) => {
    const currentTest = test;


    if (!persistedTests || !persistedTests[scope]) {
      return null;
    }

    const experienceFromQs = spartaGlobalFunctions
      .getUrlParam(`${QS_PREFIX_KEY}.${scope}.${testName}`);
    const persistedTest = persistedTests[scope][testName];

    if (experienceFromQs !== null && _.find(test.experiences, { name: experienceFromQs })) {
      currentTest.experience = experienceFromQs;
    } else if (persistedTest && _.find(test.experiences, { name: persistedTest.experience })) {
      currentTest.experience = persistedTest.experience;
    } else {
      currentTest.experience = getRandomWeightedExperience(test.experiences);
    }

    return currentTest;
  });

  persistTests(allTests);

  return allTests;
}




class SpartaExperienceUtility {



  constructor() {

    if (
      !window.spaParams
      || !spaParams.siteParams.spartaExperiences
      || spaParams.pageParams.disableSpartaExperiences === true
    ) {
      return;
    }

    this.loadExperiences();
  }





  async loadExperiences() {
    const tests = await getTestsFromManifest();
    this.chosenTests = await chooseExperiencesForTests(tests);
    this.filteredTests = await filterTests(this.chosenTests);

    this.setupFluentAPI();

    spartaEventsUtility.pub(SPARTA_EVENT_NAME, {
      filteredTests: this.filteredTests,
      chosenTests: this.chosenTests,
    });
  }



















  setupFluentAPI() {
    EXPERIENCE_SCOPES.forEach((scope) => {
      const self = this;

      this[scope] = {















        is: (testName, experienceName) => {
          const filteredPromise = self.filteredTests.then((filteredTests) => {
            const result = (
              filteredTests[scope][testName]
              && filteredTests[scope][testName].experience === experienceName
            ) ? Promise.resolve() : Promise.reject();

            return result;
          });

          return filteredPromise;
        },












        get: (testName) => {
          const filteredPromise = self.filteredTests.then((filteredTests) => {
            const result = filteredTests[scope][testName]
              ? Promise.resolve(filteredTests[scope][testName].experience)
              : Promise.reject();

            return result;
          });

          return filteredPromise;
        },
      };
    });
  }
}

export default new SpartaExperienceUtility();
